export default "__VITE_ASSET__6Mi3rh0P__"